import React from 'react';
import { Pagination } from '@material-ui/lab';
import { SelectItem } from 'ui/Input';
import TableSelect from '../../TableInputs/TableSelect/TableSelect';

import styles from './TablePagination.module.css';

interface ITablePagination {
  count: number;
  page: number;
  pageSize: number;
  totalCount: number;
  handlePageChange: (event: React.ChangeEvent<unknown>, newPage: number) => void;
  handlePageSizeChange: (event: React.ChangeEvent<{ value: unknown }>) => void;
}

const TablePagination = ({ count, page, pageSize, totalCount, handlePageChange, handlePageSizeChange }:
   ITablePagination) => {
  const calculateFrom = () => (page - 1) * pageSize + 1;
  const calculateTo = () => {
    const lastPage = Math.ceil(totalCount / pageSize);
    if (page === lastPage) {
      return totalCount;
    }
    return page * pageSize;
  };

  return (
    <div className={styles.tablePagination}>
      <Pagination
        count={count}
        page={page}
        shape="rounded"
        onChange={handlePageChange}
        className={styles.paginationWrapper}
      />
      <div className={styles.rowSelect}>
        <span className={styles.rowSelectlabel}>Entries per page:</span>
        <TableSelect
          name="pageSize"
          value={pageSize}
          className={styles.select}
          onChange={handlePageSizeChange}
          disableClearBtn
        >
          <SelectItem value="10">10</SelectItem>
          <SelectItem value="20">20</SelectItem>
          <SelectItem value="50">50</SelectItem>
        </TableSelect>
        <span className={styles.rowSelectlabel}>
          {calculateFrom()}-{calculateTo()} from {totalCount}
        </span>
      </div>
    </div>
  );
};

export default TablePagination;
